import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { TextInput } from '@opendate-app/setlist';

import RenderVideo from './RenderVideo'

var debouncedAutoSavePageDetail;

const VideoPageDetail = ({
  csrfToken,
  team,
  currentUser,
  confirm,
  pageDetail,
  pageDetailChanged,
  autoSavePageDetail
}) => {
  useEffect(() => {
    debouncedAutoSavePageDetail = _.debounce((csrfToken, team, pageDetail) => {
      autoSavePageDetail(csrfToken, team, pageDetail);
    }, 600);
  }, []);

  return (
    <div>
      <div className="form-group mb-4">
        <TextInput label="Video Link"
               error={pageDetail.video_url && pageDetail.video_url.length && !pageDetail.renderable ? "This link can't be embedded. Use a YouTube or Vimeo link." : undefined}
               value={pageDetail.video_url || ""}
               onChange={
                 (e) => {
                   var updated = Object.assign({}, pageDetail, {
                     video_url: e.target.value,
                     renderable: true
                   });

                   pageDetailChanged(updated);
                   debouncedAutoSavePageDetail(csrfToken, team, updated);
                 }
               }
               id={"page-detail-video-url-" + pageDetail.id}
               placeholder="Paste YouTube or Vimeo link" />
      </div>
      <RenderVideo pageDetail={pageDetail} />
    </div>
  );
};

VideoPageDetail.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  confirm: PropTypes.object.isRequired,
  pageDetail: PropTypes.object.isRequired,
  pageDetailChanged: PropTypes.func.isRequired,
  autoSavePageDetail: PropTypes.func.isRequired
};

export default VideoPageDetail;
